import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useRouter } from 'next/router';
import SearchIcon from '@mui/icons-material/Search';
import { Badge, ButtonBase, Button } from '@mui/material';
import dynamic from 'next/dynamic';

import { SearchbarDropdown as Dropdown } from '../shared';
import { FilterIcon } from '../svg-icon-components/filter-icon.component';

import { useCitiesData, useSelectedCity }  from '../../domain/city/city.domain'

const defaultCityText = 'Choose Location';
const defaultTermText = 'Monthly or Daily';
const defaultStyleText = 'Private or Shared';

const MobileSearchBar = (props) => {

    const {
        type,    
        roomTypes,   
        buildings,
        portfolioId,
    } = props;

    const router = useRouter();

    const { query } = router;

    const cityParam = _.get(query, 'city');

    const { data: cities } = useCitiesData();
    
    const { data: selectedCity } = useSelectedCity();    

    const [isFilterDialogOpen, setIsFilterDialogOpen] = useState(false);

    const [filterBadgeCount, setFilterBadgeCount] = useState(0);

    const [city, setCity] = useState(!cityParam ? (selectedCity ? selectedCity.name : 'Nearby') : cityParam);

    useEffect(() => {
        checkBadgeCount();
    }, [query]);

    const MobileFilterDialog =
        type === 'Bookings'
            ? dynamic(() => import('../mobile-filter-dialog/mobile-filter-dialog.component'), {
                  ssr: false,
              })
            : null;

    const checkBadgeCount = () => {
        const { term, style, building, category, guestCount, priceMin, priceMax } = query;
        const newRoom = _.get(query, 'new');
        let count = 0;

        if (term && term !== defaultTermText) {
            count += 1;
        }
        if (style && style !== defaultStyleText) {
            count += 1;
        }

        if (building) {
            if (typeof building === 'string') {
                count += 1;
            } else {
                const buildingCount = _.size(building);

                count += buildingCount;
            }
        }
        if (category) {
            if (typeof category === 'string') {
                count += 1;
            } else {
                const categoryCount = _.size(category);
                count += categoryCount;
            }
        }
        if (guestCount && guestCount !== 'Any') {
            count += 1;
        }

        if ((priceMin && priceMin !== '400') || (priceMax && priceMax !== '6000')) {
            count += 1;
        }

        if (newRoom) {
            count += 1;
        }

        setFilterBadgeCount(count);        
    };

    const onCityChange = async (value) => {
        setCity(value);
        if (type !== 'Home') {
            router.push(`/bookings?city=${value}`);
        }
    };

    const onSearchClick = () => {        
        const query = portfolioId
            ? `/bookings?city=${city}&portfolioId=${portfolioId}`
            : `/bookings?city=${city}`;
        router.push(query);
    };

    const onFilterClick = () => {
        setIsFilterDialogOpen(true);
    };

    const buildCityOptions = () => {
        const sortedCities = _.sortBy(cities, ['name']);
        return _.map(sortedCities, (_city) => {
            const cityOpt = _city;
            cityOpt.label = cityOpt.name;
            cityOpt.value = cityOpt.name;
            return cityOpt;
        });
    };

    const getDefaultOptions = (queryParam, Options) => {
        let defaultOptions = {};
        _.forEach(Options, (options) => {
            if (options.value === queryParam) {
                defaultOptions = options;
            }
        });
        return defaultOptions;
    };

    const renderCityItems = () => {
        const cityOptions = buildCityOptions();
        cityOptions.unshift({ id: 'nearby', value: 'Nearby', label: 'Nearby' });
        const defaultOptions = getDefaultOptions(city, cityOptions);

        return (
            <div className='mobile-search-bar-content-wrapper'>
                <span className='mobile-search-bar-search-bar-headings'>Location</span>
                <Dropdown
                    type={type}
                    options={cityOptions}
                    onChange={onCityChange}
                    placeholder={defaultCityText}
                    defaultSelected={defaultOptions}
                    selectId="city_dropdown"
                />
            </div>
        );
    };

    const renderMobileHome = () => {
        if (type !== 'Home' && type !== 'Filters' && type !== 'Portfolio') {
            return null;
        }

        return (
            <div className='mobile-search-bar-container'>
                <div className='mobile-search-bar-row'>
                    <div className='mobile-search-bar-col-last'>{renderCityItems()}</div>
                    <div className='mobile-search-bar-col'>
                        <Button
                            id="mobile_search_button"
                            className='mobile-search-bar-search-button'
                            startIcon={<SearchIcon />}
                            onClick={onSearchClick}
                        >
                            Search
                        </Button>
                    </div>
                </div>
            </div>
        );
    };

    const renderMobileBookings = () => {
        if (type !== 'Bookings') {
            return null;
        }

        return (
            <div className='mobile-search-bar-container'>
                <div className='mobile-search-bar-row'>
                   <div className='mobile-search-bar-col-last'>{renderCityItems()}</div>
                    <ButtonBase
                        id="mobile_search_button"
                        onClick={onFilterClick}
                        className='mobile-search-bar-filter-button'
                    >
                        
                        <Badge badgeContent={filterBadgeCount} className='mobile-search-bar-badge'>
                            <FilterIcon fill="transparent" stroke="white" />
                        </Badge>
                        
                    </ButtonBase>
                </div>
            </div>
        );
    };

    const renderFilterDialog = () => {
        if (type !== 'Bookings') {
            return null;
        }

        return <MobileFilterDialog isOpen={isFilterDialogOpen} setIsOpen={setIsFilterDialogOpen} roomTypes={roomTypes} buildings={buildings} />;
    };

    return (
        <>
            {renderMobileHome()}
            {renderMobileBookings()}
            {renderFilterDialog()}
        </>
    );
};


export default MobileSearchBar;

MobileSearchBar.propTypes = {    
    type: PropTypes.string,    
    roomTypes: PropTypes.array,
    buildings: PropTypes.object,
    portfolioId: PropTypes.string,
};
